let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gcHxg")).then(() => parcelRequire('h2zFV'));